import { ddmmyyyyStringToDateID } from "../../../../utilities/dateUtils";
import { agregarPadStart, agregarPadStartDDMMYYYY } from "../../../../utilities/xlsxUtils";
import { FCIPriceExcelItem, FCIPriceItem, FCIPriceItemEndpoint } from "../domain/FundsPricesImport.model";

export type FCIPriceItemWithoutInstrument = Omit<FCIPriceItem, "investmentInstrument">;

export const createAdapterFromXLSXToFCIPrice = (
  fciPriceExcelItem: FCIPriceExcelItem
): FCIPriceItemWithoutInstrument => {
  const rawPrice = fciPriceExcelItem["Precio de Cierre"] || "-";
  const closingPrice =
    typeof rawPrice === "string" && rawPrice.trim() !== "-"
      ? (() => {
          const cleaned = rawPrice.replace(/,/g, '');
          const [intPart, decPart = ''] = cleaned.split('.');
          return `${intPart}.${decPart.slice(0, 6).padEnd(6, '0')}`;
        })()
      : "-";

  return {
    date: agregarPadStartDDMMYYYY(fciPriceExcelItem["Fecha"]) || "-",
    isin: fciPriceExcelItem["Instrumento (SSN)"],
    closingPrice: closingPrice,
  };
};

export const createAdapterFromFCIPriceToEndpoint = (
  fciPriceItem: FCIPriceItem
): FCIPriceItemEndpoint => {
  const formattedItem: FCIPriceItemEndpoint = {
    Fecha: ddmmyyyyStringToDateID((fciPriceItem.date).toString(), "/"),
    InstrumentoInversionID: fciPriceItem.investmentInstrument.id!,
    PrecioCierre: !isNaN(parseInt(fciPriceItem.closingPrice.toString())) ? parseFloat(fciPriceItem.closingPrice.toString().replace(/,/g, '')) : 0,
  };
  return formattedItem;
};